<template>
  <div>
    <AccountingParentBar />
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div class="my-4">
          <v-row class="bg-white mx-0">
            <v-col cols="12" class="text-center">
              <h1>{{ $t('credit_note.title') }}</h1>
            </v-col>
            <v-col cols="10">
              <v-row>
                <v-col cols="6">
                  <v-menu v-model="menuStartDate" :close-on-content-click="false" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :value="$helper.datelabel(formData.startDate)" :placeholder="$t('date')" outlined dense
                        hide-details readonly v-bind="attrs" v-on="on" :label="$t('from_date')"></v-text-field>
                    </template>
                    <v-date-picker v-model="formData.startDate" no-title locale="th" @input="menuStartDate = false"
                      :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu v-model="menuEndDate" :close-on-content-click="false" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :value="$helper.datelabel(formData.endDate)" :placeholder="$t('date')" outlined dense
                        hide-details readonly v-bind="attrs" v-on="on" :label="$t('to_date')"></v-text-field>
                    </template>
                    <v-date-picker v-model="formData.endDate" no-title locale="th" @input="menuEndDate = false"
                      :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="2" class="text-center">
              <v-btn @click="initData()" class="primary" block :disabled="isLoading">
                <v-icon>mdi-magnify</v-icon>{{ $t('search') }}
              </v-btn>
            </v-col>
            <v-col cols="12" class="text-center pt-5 grey lighten-4">
              <h2>
                <b>{{ $t('date_list') }}</b>
                {{ $helper.datelabel(tempDate.startDate) }} -
                {{ $helper.datelabel(tempDate.endDate) }}
              </h2>
              <div class="text-end">
                <v-btn @click="exportCreditNote()" class="blue white--text mx-1" :disabled="isLoading">
                  <v-icon class="me-2">mdi-file-excel-outline</v-icon>Export Excel
                </v-btn>
                <v-menu v-if="!isShowSelectPrintCreditNote">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="blue white--text mx-1" :disabled="isLoading" v-bind="attrs" v-on="on">
                      <v-icon class="me-2">mdi-printer</v-icon>{{ $t('credit_note.print_credit_note') }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="printCreditNote('all')">
                      <v-list-item-title>{{ $t('credit_note.print_all_credit_note') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="choosePrintCreditNote('select')">
                      <v-list-item-title>{{ $t('bill.select_bill') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <template v-else>
                  <v-btn class="info mx-1" @click="printCreditNote('select')"
                    :disabled="isLoading || selectedCreditNotes.length <= 0">
                    <v-icon left>mdi-printer</v-icon>
                    {{ $t('bill.print_bill', { count: selectedCreditNotes.length }) }}
                  </v-btn>
                </template>
                <v-btn v-show="isShowSelectPrintCreditNote" class="error mx-1"
                  @click="selectedCreditNotes = []; isShowSelectPrintCreditNote = false;">{{ $t('cancel') }}</v-btn>
              </div>
            </v-col>
            <v-col v-if="!isFirstLoading" cols="12" class="px-0 pt-0 pb-4 grey lighten-4">
              <v-data-table
                v-if="dataTable && dataTable.data"
                :headers="dataTable.headers"
                :items="dataTable.data"
                :items-per-page="10"
                class="elevation-1 data-table-credit-note"
                item-key="objectId"
                @click:row="rowClick"
                v-model="selectedCreditNotes"
                :show-select="isShowSelectPrintCreditNote"
                :single-select="false"
                ref="dataTableCreditNote"
                :loading="isLoading"
                :footer-props="{
                  'items-per-page-options': [10, 20, 50, 100],
                }"
                :no-data-text="$t('noinfo')"
                :no-results-text="$t('no_matching_records_found')"
              >
                <template v-slot:header.areaName="{header}">
                  <div class="text-nowrap-table text-center" style="min-width: 100px;">{{header.text}}</div>
                </template>
                <template v-slot:header.customerDataName="{header}"> 
                  <div class="text-nowrap-table text-center" style="min-width: 100px;">{{header.text}}</div>
                </template>
                <template v-slot:header.businessName="{header}"> 
                  <div class="text-nowrap-table text-center" style="min-width: 100px;">{{header.text}}</div>
                </template>

                <template v-slot:body.prepend>
                  <tr>
                    <td class="text-center" :colspan="isShowSelectPrintCreditNote ? 2 : 1">
                      <v-icon>mdi-filter-multiple-outline</v-icon>
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.documentId" type="text" :label="$t('market.document_id')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.invoiceId" type="text" :label="$t('invoice.title')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.contractCheckoutId" type="text" :label="$t('market.checkout')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.areaName" type="text" :label="$t('market.market_title')" solo dense hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.customerMarketId" type="text" :label="$t('bill.customer_market_id')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.customerName" type="text" :label="$t('market.marchant_name')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0">
                      <v-text-field v-model="filterData.businessName" type="text" :label="$t('bill.business_name')" solo dense
                        hide-details />
                    </td>
                    <td class="ps-0 pe-0">
                      <v-currency-field v-model="filterData.totalValue" class="input-right input-disable-appearance"
                        :label="$t('market.total_value')" solo dense hide-details />
                    </td>
                  </tr>
                </template>
                <template v-slot:item.data-table-select="{ isSelected, select, item }">
                  <template v-if="isShowSelectPrintCreditNote && item.isSent">
                    <v-simple-checkbox color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
                  </template>
                </template>
                <template v-slot:item.date="{ item }">
                  <template v-if="item.date">{{ $moment(item.date).format("DD/MM/YYYY") }}</template>
                </template>
                <template v-slot:item.areaName="{ item }">
                  <div class="text-truncate text-center area-name">{{ item.areaName }}</div>
                </template>
                <template v-slot:item.customerDataName="{ item }">
                  <div class="text-truncate text-center customer-name">{{ item.customerDataName }}</div>
                </template>
                <template v-slot:item.businessName="{ item }">
                  <div class="text-truncate text-center customer-name">{{ item.businessName }}</div>
                </template>
                <template v-slot:item.totalValue="{ item }">{{ item.totalValue | currency }}</template>
              </v-data-table>
            </v-col>
            <v-col v-else>
              <v-card class="d-flex justify-center py-10">
                <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </template>
    </layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <CreditNoteDialog v-model="isCreditNoteDialog" :creditNoteId="creditNoteId" :projectId="projectId" />
    <PrintDialog elementId="print-credit-note-accounting" type="credit-note" v-model="isPrintDialog"
      :creditNoteIds="selectedCreditNotes.map(d => d.objectId)" />
  </div>
</template>

<script>
import CreditNoteDialog from "@/components/CreditNoteDialog.component";
import SelectMonthYear from "@/components/SelectMonthYear.component";
import ParentBar from "@/components/ParentBar.vue";
import AccountingParentBar from "../../components/AccountingParentBar.component";
import { ExportAccounting } from "../../exports";
import Layout from "@/components/Layout.vue";
import { mapState, mapActions } from "vuex";
import PrintDialog from "../../components/PrintDialog.component.vue";
import { CreditNote } from "@/classes";
export default {
  computed: {
    ...mapState({
      creditNotes: state => state.creditNote.creditNotes
    }),
    dataTable() {
      return {
        headers: [
          {
            text: this.$t('date'),
            value: "date",
            width: "8%"
          },
          {
            text: this.$t('market.document_id'),
            value: "documentId",
            width: "12%",
            filter: d =>
              this.filterData.documentId
                ? d
                  .toLowerCase()
                  .includes(this.filterData.documentId.toLowerCase())
                : d
          },
          {
            text: this.$t('invoice.title'),
            value: "invoiceId",
            width: "12%",
            filter: d =>
              this.filterData.invoiceId
                ? d
                  .toLowerCase()
                  .includes(this.filterData.invoiceId.toLowerCase())
                : d
          },
          {
            text: this.$t('market.checkout'),
            value: "contractCheckoutId",
            width: "12%",
            filter: d =>
              this.filterData.contractCheckoutId
                ? d
                  .toLowerCase()
                  .includes(this.filterData.contractCheckoutId.toLowerCase())
                : d
          },
          {
            text: this.$t('market.market_title'),
            width: "1%",
            class: "custom-sort",
            value: "areaName",
            align: "center hd-resize",
            filter: d =>
              this.filterData.areaName
                ? d
                  .toLowerCase()
                  .includes(this.filterData.areaName.toLowerCase())
                : d
          },
          {
            text: this.$t('bill.customer_market_id'),
            value: "contractCustomerMarketId",
            align: "center",
            filter: d =>
              this.filterData.customerMarketId
                ? d.includes(this.filterData.customerMarketId)
                : d
          },
          {
            text: this.$t('market.marchant_name'),
            value: "customerDataName",
            width: "1%",
            class: "custom-sort",
            align: "center hd-resize",
            filter: d =>
              this.filterData.customerName
                ? d
                  .toLowerCase()
                  .includes(this.filterData.customerName.toLowerCase())
                : d
          },
          {
            text: this.$t('bill.business_name'),
            value: "businessName",
            width: "1%",
            class: "custom-sort",
            align: "center hd-resize",
            filter: d =>
              this.filterData.businessName
                ? d
                  .toLowerCase()
                  .includes(this.filterData.businessName.toLowerCase())
                : d
          },
          {
            text: this.$t('market.total_value'),
            value: "totalValue",
            align: "right",
            filter: d =>
              this.filterData.totalValue
                ? d.toString().includes(this.filterData.totalValue)
                : d || d === 0
          }
        ],
        data: this.creditNotes
      };
    },
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,
      market: null,
      isCreditNoteDialog: false,
      selectedMonthYear: null,
      isError: false,
      isLoading: false,
      isFirstLoading: false,
      creditNoteId: null,
      menuStartDate: false,
      menuEndDate: false,
      formData: {
        startDate: this.$moment({ day: 1 }).format("YYYY-MM-DD"),
        endDate: this.$moment()
          .endOf("month")
          .format("YYYY-MM-DD")
      },
      tempDate: null,
      isShowSelectPrintCreditNote: false,
      selectedCreditNotes: [],
      isPrintDialog: false,
      filterData: {
        documentId: null,
        invoiceId: null,
        contractCheckoutId: null,
        areaName: null,
        customerName: null,
        businessName: null,
        totalValue: null,
        customerMarketId: ""
      },
    };
  },
  components: {
    CreditNoteDialog,
    SelectMonthYear,
    ParentBar,
    AccountingParentBar,
    Layout,
    PrintDialog
  },
  async created() {
    this.initData();
  },
  methods: {
    async initData() {
      this.isLoading = true;
      this.isFirstLoading = true;
      try {
        this.selectedCreditNotes = [];
        this.tempDate = JSON.parse(JSON.stringify(this.formData));
        let params = {
          marketId: this.marketId,
          startDate: this.$moment(this.formData.startDate)
            .startOf("day")
            .toISOString(),
          endDate: this.$moment(this.formData.endDate)
            .endOf("day")
            .toISOString()
        }
        this.$store.commit("creditNote/setCreditNotes", []);
        await this.$helper.queryMore(
          CreditNote.getCreditNotesBetweenDateByMarket,
          params,
          null,
          (results) => {
            this.$store.commit("creditNote/addCreditNotes", results);
            this.isFirstLoading = false;
          }
        );
        this.isFirstLoading = false;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        this.isLoading = false;
        this.isFirstLoading = false;
        this.isError = true;
      }
    },
    exportCreditNote() {
      try {
        let filterCreditNotes = this.$refs.dataTableCreditNote.$children[0].filteredItems
        ExportAccounting.exportCreditNoteList(
          filterCreditNotes,
          this.formData.startDate,
          this.formData.endDate
        );
      } catch (err) {
        this.isError = true;
      }
    },
    rowClick(creditNote) {
      this.creditNoteId = creditNote.objectId;
      this.isCreditNoteDialog = true;
    },
    choosePrintCreditNote(type) {
      let filterCreditNotes = this.$refs.dataTableCreditNote.$children[0].filteredItems
      this.selectedCreditNotes = [];
      if (type == "all") {
        this.selectedCreditNotes = filterCreditNotes.filter(d => d.isSent);
      } 
      this.isShowSelectPrintCreditNote = true;
    },
    printCreditNote(type) {
      let filterCreditNotes = this.$refs.dataTableCreditNote.$children[0].filteredItems
      if (type == "all") {
        this.selectedCreditNotes = filterCreditNotes.filter(d => d.isSent);
      }
      this.isPrintDialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-data-table::v-deep td {
  max-width: 250px;
}

.data-table-credit-note::v-deep td.hd-resize {
  max-width: 100px;
}

.data-table-credit-note::v-deep th.custom-sort {
  position: relative;
  .v-icon{
    position: absolute;
    right: 24px;
    top: 18px;
  }
}

.text-nowrap-table.market-name,
.text-nowrap-table.area-name,
.text-nowrap-table.customer-name {
  width: 100%;
}
</style>